import { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import ServiceWorkerController from '#service-worker/controller';

/**
 * Triggers service worker initialization
 * based on user siteMsg settings.
 */

const useServiceWorker = () => {
  const { siteMsg } = useSelector(s => s.account, shallowEqual);

  useEffect(() => {
    if (siteMsg === 1) {
      ServiceWorkerController.initSW();
    }
  }, [siteMsg]);
};

export default useServiceWorker;
